import { getVidal } from '../api-config';

export const getMedications = async (data: any, params: any) => await getVidal(data, params);
